import { z } from "zod";
export const operators = [
    "eq",
    "neq",
    "c",
    "gt",
    "gte",
    "lt",
    "lte",
    "t",
    "f",
    "null",
    "nnull"
];
export const operatorLabelLookup = {
    eq: "is",
    neq: "is not",
    c: "contains",
    gt: "greater than",
    gte: "greater than or equal to",
    lt: "less than",
    lte: "less than or equal to",
    t: "is true",
    f: "is false",
    null: "is null",
    nnull: "is not null"
};
export const callingObject = z.enum([
    "device",
    "user",
    "params",
    "computed"
]);
export const computedFunctions = z.enum([
    "minutesSince",
    "hoursSince",
    "daysSince"
]);
export const operatorOptions = operators.map((m)=>({
        value: m,
        label: operatorLabelLookup[m]
    }));
export const rhsValueOptions = [
    "string",
    "number",
    "boolean"
];
export const rhsValueLabelLookup = {
    string: "text",
    number: "number",
    boolean: "boolean"
};
export const rhsValueDropdownOptions = rhsValueOptions.map((m)=>({
        value: m,
        label: rhsValueLabelLookup[m]
    }));
const RHSNumberSchema = z.object({
    type: z.literal("number"),
    value: z.string().min(1)
});
const RHSStringSchema = z.object({
    type: z.literal("string"),
    value: z.string()
});
const RHSBooleanSchema = z.object({
    type: z.literal("boolean"),
    value: z.string()
});
export const ComputedFunctionSchema = z.object({
    type: z.literal("computed_function"),
    caller: callingObject,
    name: computedFunctions,
    args: z.string()
}).transform((data)=>({
        ...data,
        value: `$${data.caller}.$${data.name}(${data.args})`
    }));
const PropertySchema = z.object({
    type: z.literal("property"),
    value: z.string()
});
export const ConditionSchema = z.lazy(()=>z.union([
        z.object({
            type: z.literal("condition"),
            lhs: z.union([
                ComputedFunctionSchema,
                PropertySchema
            ]),
            operator: z.enum(operators),
            rhs: z.union([
                RHSNumberSchema,
                RHSStringSchema,
                RHSBooleanSchema,
                ComputedFunctionSchema,
                PropertySchema
            ])
        }),
        z.object({
            type: z.literal("group"),
            operator: z.enum(conditionOperators),
            conditions: z.array(ConditionSchema)
        })
    ]));
const RHSListSchema = z.object({
    type: z.literal("list"),
    value: z.array(ConditionSchema)
});
export const conditionOperators = [
    "and",
    "or"
];
export const entitlementOperators = [
    "not_contains",
    "empty"
];
// export const RuleEditorEntitlementNotContainsSchema = z.object({
//   type: z.literal("not_contains_all"),
//   operator: z.literal("not_contains_all"),
//   value: z.array(z.string()),
// })
export const RuleEditorSingleEntitlementStatusSchema = z.object({
    type: z.literal("entitlement_condition"),
    identifier: z.string(),
    status: z.enum([
        "active",
        "inactive",
        "will_not_renew",
        "in_trial",
        "expired"
    ])
});
export const RuleEditorEntitlementStatusSchema = z.object({
    type: z.literal("entitlement_conditions"),
    conditions: z.array(RuleEditorSingleEntitlementStatusSchema)
});
export const RuleEditorEntitlementEmptySchema = z.object({
    type: z.literal("no_active_entitlements")
});
export const RuleEditorEntitlementAllUsersSchema = z.object({
    type: z.literal("always_true")
});
export const RuleEditorEntitlementAnyWillNotRenewSchema = z.object({
    type: z.literal("any_will_not_renew")
});
export const RuleEditorEntitlementAnyInTrialSchema = z.object({
    type: z.literal("any_in_trial")
});
export const RuleEditorEntitlementAnyExpiredNoActiveSchema = z.object({
    type: z.literal("any_expired_no_active")
});
export const RuleEditorEntitlementAnyActiveSubsAutoRenewDisabledSchema = z.object({
    type: z.literal("any_active_subs_auto_renew_disabled")
});
export const RuleEditorEntitlementSchema = z.object({
    type: z.literal("entitlement"),
    rule: z.union([
        RuleEditorEntitlementEmptySchema,
        // RuleEditorEntitlementNotContainsSchema,
        RuleEditorEntitlementAllUsersSchema,
        RuleEditorEntitlementStatusSchema,
        RuleEditorEntitlementAnyWillNotRenewSchema,
        RuleEditorEntitlementAnyInTrialSchema,
        RuleEditorEntitlementAnyExpiredNoActiveSchema,
        RuleEditorEntitlementAnyActiveSubsAutoRenewDisabledSchema
    ])
});
export const RuleEditorSchema = z.object({
    operator: z.enum(conditionOperators),
    conditions: z.array(ConditionSchema),
    entitlements: RuleEditorEntitlementSchema.optional()
});
